var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 9.51087V11.268C1.27148 11.8198 1.67358 12.2219 2.16937 12.2219H9.69326C9.69054 12.1762 9.68945 12.1299 9.68945 12.0836C9.69108 10.7112 10.804 9.59993 12.1762 9.59993V3.92132C12.1762 3.42556 11.7743 3.02344 11.2783 3.02344H10.2914V3.45986C10.2914 3.77486 10.0363 4.03022 9.72127 4.03022C9.40654 4.03022 9.15145 3.77486 9.15145 3.45986V3.02344H7.29389V3.45986C7.29389 3.77486 7.03825 4.03022 6.72352 4.03022C6.40907 4.03022 6.1537 3.77486 6.1537 3.45986V3.02344H4.2959V3.45986C4.2959 3.77486 4.04081 4.03022 3.72608 4.03022C3.41135 4.03022 3.15602 3.77483 3.15602 3.45986V3.02344H2.16937C1.67361 3.02344 1.27148 3.42554 1.27148 3.92132V7.11561",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1762 3.92138V5.20721H1.27148V3.92138C1.27148 3.42562 1.67364 3.02344 2.1694 3.02344H3.15618V3.45997C3.15618 3.77491 3.41133 4.03009 3.7263 4.03009C4.04097 4.03009 4.29612 3.77494 4.29612 3.45997V3.02344H6.15373V3.45997C6.15373 3.77491 6.40915 4.03009 6.72385 4.03009C7.03852 4.03009 7.29397 3.77494 7.29397 3.45997V3.02344H9.15158V3.45997C9.15158 3.77491 9.40673 4.03009 9.7214 4.03009C10.0363 4.03009 10.2915 3.77494 10.2915 3.45997V3.02344H11.2783C11.7744 3.02344 12.1762 3.42559 12.1762 3.92138Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72724 4.0292C3.41243 4.0292 3.15723 3.774 3.15723 3.45919V2.57001C3.15723 2.2552 3.41243 2 3.72724 2C4.04205 2 4.29725 2.2552 4.29725 2.57001V3.45919C4.29725 3.774 4.04205 4.0292 3.72724 4.0292Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72431 4.0292C6.4095 4.0292 6.1543 3.774 6.1543 3.45919V2.57001C6.1543 2.2552 6.4095 2 6.72431 2C7.03912 2 7.29432 2.2552 7.29432 2.57001V3.45919C7.29429 3.774 7.03912 4.0292 6.72431 4.0292Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72235 4.0292C9.40754 4.0292 9.15234 3.774 9.15234 3.45919V2.57001C9.15234 2.2552 9.40754 2 9.72235 2C10.0372 2 10.2924 2.2552 10.2924 2.57001V3.45919C10.2923 3.774 10.0371 4.0292 9.72235 4.0292Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02705 6.66901L7.47182 7.57024C7.52084 7.66956 7.61556 7.7384 7.72517 7.75432L8.71974 7.89885C8.99574 7.93894 9.10592 8.27811 8.90621 8.47278L8.18653 9.17429C8.10721 9.25159 8.07104 9.36296 8.08977 9.47211L8.25966 10.4627C8.30681 10.7376 8.01829 10.9472 7.77145 10.8174L6.88186 10.3497C6.78385 10.2982 6.66673 10.2982 6.56871 10.3497L5.67913 10.8174C5.43228 10.9472 5.14377 10.7376 5.19091 10.4627L5.36081 9.47211C5.37953 9.36296 5.34333 9.25159 5.26404 9.17429L4.54436 8.47278C4.34466 8.27811 4.45486 7.93894 4.73083 7.89885L5.7254 7.75432C5.83498 7.7384 5.92973 7.66956 5.97875 7.57024L6.42353 6.66901C6.54699 6.41892 6.90361 6.41892 7.02705 6.66901Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.27219,
    cy: 8.29855,
    r: 0.272186,
    fill: "black",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6189 12.5586C14.8797 11.2102 13.9981 9.90569 12.6497 9.64488C11.3012 9.38407 9.99672 10.2657 9.73591 11.6142C9.4751 12.9626 10.3568 14.2671 11.7052 14.5279C13.0536 14.7887 14.3581 13.907 14.6189 12.5586Z",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1772 10.7334V12.0858L11.5361 12.7268",
    stroke: "#296BCD",
    strokeWidth: 0.544371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.5cc46616d3b90657af4a359205909baf.svg";
export { ForwardRef as ReactComponent };